
import { Skeleton } from "@/components/ui/skeleton";
import { Separator } from "@/components/ui/separator";

export const EvaluationSkeleton = () => {
  return (
    <div className="space-y-6">
      <div className="space-y-4">
        {[1, 2, 3, 4].map((i) => (
          <Skeleton key={i} className="h-4 w-full" />
        ))}
      </div>

      <Separator className="dark:border-stone-600" />

      <div className="grid gap-4 grid-cols-1 md:grid-cols-5">
        <div className="text-center col-span-1 md:col-span-1 bg-white dark:bg-stone-800 p-4 rounded-lg border border-stone-100 dark:border-stone-700">
          <Skeleton className="h-8 w-full mb-2" />
          <Skeleton className="h-4 w-1/2 mx-auto" />
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 col-span-1 md:col-span-4 gap-4">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="text-center bg-white dark:bg-stone-800 p-4 rounded-lg border border-stone-100 dark:border-stone-700">
              <Skeleton className="h-8 w-full mb-2" />
              <Skeleton className="h-4 w-2/3 mx-auto" />
            </div>
          ))}
        </div>
      </div>

      <Separator className="dark:border-stone-600" />

      <div className="space-y-8">
        {["Strengths", "Areas for Improvement", "Suggestions"].map((section) => (
          <div key={section} className="space-y-4">
            <Skeleton className="h-6 w-32" />
            {[1, 2].map((i) => (
              <div key={i} className="space-y-2">
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-5/6" />
                <Skeleton className="h-4 w-2/3" />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
